import { Box, ResponsiveValue } from "@chakra-ui/react";
import { FC } from "react";

interface Props {
  x?: ResponsiveValue<string>;
  y?: ResponsiveValue<string>;
}

const Spacer: FC<Props> = ({ x, y }) => {
  return <Box display="block" mr={x} mt={y} />;
};

export default Spacer;
